import { useModal } from "context/modal/modal.provider";
import useTranslation from "next-translate/useTranslation";
import Image from "next/legacy/image";
import NewFeedback from "./NewFeedback";

const ButtonFeedback = () => {
  const { openModal } = useModal();
  const { t } = useTranslation("common");
  const onModalOpen = () => {
    openModal({
      eyebrow: t("Feedback"),
      title: t("newFeedback.title"),
      bodyClassName: "px-4 py-4 sm:px-5 sm:py-5",
      modalComponent: <NewFeedback hideFooter />,
      size: "md",
    });
  };

  return (
    <div className="cursor-pointer">
      <Image
        src="/svg/feedback.svg"
        onClick={onModalOpen}
        className="cursor-pointer"
        width={45}
        height={45}
        alt="Feedback"
      />
    </div>
  );
};

export default ButtonFeedback;
